import "./MobileHistorypage.css";
import HistoryText from "../../Components/HistoryText";

export default function MobileHistory() {
  return (
    <div className="mobile-p-history-margin">
      <HistoryText />
    </div>
  );
}
